export const COUNT = 'count';
export const LATEST = 'latest';

export const DESC = 'desc';
export const ASC = 'asc';

export const SORT_BY_ORDERS = [COUNT, LATEST];
export const SORT_DIRECTIONS = [DESC, ASC];
